import React from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { push } from "react-router-redux"
import { Route, Link, Switch } from "react-router-dom"
import {
  Slider,
  Select,
  Button as AButton,
  Col,
  Row,
  Icon as AIcon,
  Radio,
  Tooltip,
  Dropdown,
  Menu,
  Input,
  Modal
} from "antd"

import {
  MoreIcon,
  CheckedIcon,
  InvoiceIcon,
  VisaLogo,
  MastercardLogo,
  AmericanExpressLogo,
  DiscoverLogo,
  DinersClubLogo,
  JCBLogo
} from "../core/icons"
import Line from "../core/Line"
// import CreateSubscriptionSuccessModal from "./CreateSubscriptionSuccessModal"

import Card, { TitleCard, CardHeader } from "../core/Card"
import { getPlans, getInvoices, handleCancelReactivateClick } from "./actions"
import onMount from "../core/onMount"
import twix from "twix"
import moment from "moment"
import numeral from "numeral"

import Features from "./Features"
import PlanLines from "./PlanLines"
import FAQ from "./FAQ"
import ConnectedPlan from "./ConnectedPlan"
import PremiumFeatures from "./PremiumFeatures"
import NewStripeForm from "./NewStripeForm"
import {
  CreateSubModal,
  UpdateSubModal,
  ManageStripeForm,
  CancelOrReactivateSub
} from "./"

const Billing = connect(
  state => {
    const { customer } = state.models.user.subscription || {
      customer: { source: {} }
    }
    const { name, email, last } = state.models.user
    const isTeamOwner = !!state.models.user.group_as_enterprise_owner
    return {
      name,
      last,
      email,
      customer,
      source: customer.source,
      willSendInvoice:
        state.models.user.subscription.stripe_billing == "send_invoice"
    }
  },
  dispatch => {
    return {
      handleUpdateCardSelect: () => dispatch({ type: "UPDATE_CARD_SELECT" })
    }
  }
)(
  ({
    name,
    last,
    email,
    customer,
    source,
    willSendInvoice,
    handleUpdateCardSelect
  }) => (
    <Card>
      {/* <CardHeader
        title="Payment Method"
        buttonTitle="Change"
        buttonOnClick={handleUpdateCardSelect}
      /> */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 20
        }}
      >
        <h1 style={{ margin: 0 }}>Payment Method</h1>
        <AButton onClick={handleUpdateCardSelect}>Change</AButton>
      </div>

      {willSendInvoice ? (
        <Row type="flex" justify="center" align="middle">
          <InvoiceIcon />{" "}
          <span style={{ padding: 10 }}>
            Send invoice to: <b>{email}</b>
          </span>
        </Row>
      ) : (
        <Row
          type="flex"
          // justify="center"
          align="middle"
          style={{ padding: 10 }}
          gutter="20"
        >
          <Col xs={0} sm={3} />
          <Col sm={2}>
            {source.brand == "Visa" && <VisaLogo />}
            {source.brand == "MasterCard" && <MastercardLogo />}
            {source.brand == "American Express" && <AmericanExpressLogo />}
            {source.brand == "Discover" && <DiscoverLogo />}
            {source.brand == "Diners Club" && <DinersClubLogo />}
            {source.brand == "JCB" && <JCBLogo />}
          </Col>
          <Col sm={5}>
            {name} {last}
          </Col>
          <Col sm={6}>
            <span style={{ opacity: 0.5, paddingRight: 10 }}>Ends with: </span>****{" "}
            {source.last4}
          </Col>
          <Col sm={3}>
            <span style={{ opacity: 0.5, paddingRight: 10 }}>Exp:</span>
            {source.exp_month}/{source.exp_year}
          </Col>
        </Row>
      )}
    </Card>
  )
)
export default Billing



// WEBPACK FOOTER //
// ./src/subscriptions/Billing.js